import * as Utils from 'utils';

export const orderMiddleware = () => (next) => (currentAction) => {
  let action = {...currentAction};
  let data = {};

  if (currentAction.type === 'order/checkAndUpdateIfOrderExists') {
    if (localStorage.getItem('isFromCheckoutPage') && window['orderPageLoadConfig'] && Object.keys(window['orderPageLoadConfig']).length) {
      data = window['orderPageLoadConfig'];
      const userProfileDecoded = Utils.decodeHtmlInObject(data.information);

      action = {
        ...action,
        payload: {
          orderInformation: {
            attachments: data.attachments,
            checklist: data.checklist,
            eta: data.eta,
            total: data.total,
            information: {
              ...data.information,
              ...userProfileDecoded
            },
          },
          orderInformationTempAmazon: data.attachments.amazon || []
        },
      };
    }
  }
  next(action);
}
